import { useRef, type ReactNode } from "react";
import { PageHeader } from "./PageHeader";
import { FormActionsBar } from "./FormActionsBar";

interface FormPageShellProps {
  title: string;
  subtitle?: string;
  backTo?: string;
  backLabel?: string;
  submitLabel?: string;
  cancelLabel?: string;
  onCancel?: () => void;
  loading?: boolean;
  headerActions?: ReactNode;
  children: ReactNode;
}

export const FormPageShell = ({
  title,
  subtitle,
  submitLabel,
  cancelLabel = "Cancelar",
  onCancel,
  loading = false,
  headerActions,
  children,
}: FormPageShellProps) => {
  const showActionBar =
    !headerActions && submitLabel && onCancel;
  const contentRef = useRef<HTMLDivElement>(null);

  const handleSubmit = () => {
    contentRef.current?.querySelector("form")?.requestSubmit();
  };

  return (
    <div className="space-y-4">
      <PageHeader
        title={title}
        subtitle={subtitle}
        actions={
          headerActions ?? (
            <button
              type="button"
              onClick={onCancel}
              className="rounded-md px-3 py-1.5 text-sm text-ink-secondary hover:bg-slate-100"
            >
              {cancelLabel}
            </button>
          )
        }
      />
      <div ref={contentRef}>{children}</div>
      {showActionBar ? (
        <FormActionsBar
          submitLabel={submitLabel!}
          cancelLabel={cancelLabel}
          onCancel={onCancel!}
          onSubmit={handleSubmit}
          loading={loading}
        />
      ) : null}
    </div>
  );
};
